import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from "../../client-server-common/doppe-action-types/doppe-action-type";
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";

export interface DoppeActionTypePlaceholderSettings {}

export const doppeActionTypePlaceholder = doppeActionTypeDefineMetadata<DoppeActionTypePlaceholderSettings>({
    id: 'io.bymo.action/placeholder',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({}),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {},
        bindableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    canRenderInPage: true,
    isWidgetOpener: true
})
